import { Flex } from 'components/box';
import { Text, Heading } from 'components/typography';
import { AlertTriangle } from 'react-feather';
import { css } from '@emotion/react';

const SearchErrorFallback = () => (
  <Flex
    mt={2}
    flexDirection="column"
    alignItems="center"
    textAlign="center"
    paddingX="5px"
    css={css`
      gap: 5px;
    `}
    height={['90vh', '75vh']}
  >
    <AlertTriangle size={30} color="#FFC107" />
    <Heading fontSize={['0.9rem', 'm']}>Oops! Something went wrong.</Heading>

    <Text lineHeight={1.5}>
      There was a problem with the search functionality. Please refresh the page
      and try again.
    </Text>
  </Flex>
);

export default SearchErrorFallback;
